import React from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from '../../redux/store';
import { Link } from '@reach/router';
import { I18n } from '@kineticdata/react';
import classNames from 'classnames';
import {
  Card,
  CardCol,
  CardRow,
  C,
  Image,
  Utils,
} from '@kineticdata/bundle-common';
import { Form } from '../../models';

export const FormCardComponent = props => {
  const { path, favorites, components = {} } = props;
  const form = Form(props.form);
  return (
    <Card to={path} components={{ Link, ...components }}>
      {form.image && <Image src={form.image} alt="" />}
      <CardRow className="py-4">
        <CardRow type="prepend" className="text-muted">
          <span
            className={`fa fa-2x fa-${(form.icon || 'ticket').replace(
              /^fa-/i,
              '',
            )} fa-fw`}
          />
        </CardRow>
        <CardCol>
          <CardRow type="subtitle">
            <span>
              <I18n>{form.name}</I18n>
            </span>
            {form.fundingDependent && (
              <span
                className="badge badge-subtle badge-sm ml-1 align-self-center"
                title="Funding Dependent"
              >
                <span className="fa fa-dollar-sign" />
              </span>
            )}
          </CardRow>
          <CardRow className="text-muted">
            <span>
              {form.isInternal && (
                <span
                  className="badge badge-subtle badge-sm align-self-center mr-1"
                  title="Internal Service Offering"
                >
                  <I18n>Internal</I18n>
                </span>
              )}
              <I18n>{form.description}</I18n>
            </span>
          </CardRow>
        </CardCol>
        {!props.hideFavorite && (
          <CardRow type="append">
            <button
              className="btn btn-icon toggle-favorite"
              onClick={props.handleToggleFavorite}
              title="Toggle Favorite"
            >
              <span
                className={classNames(
                  {
                    'fa text-primary': favorites.includes(form.slug),
                    'far text-dark': !favorites.includes(form.slug),
                  },
                  'fa-lg fa-heart',
                )}
              />
            </button>
          </CardRow>
        )}
      </CardRow>
    </Card>
  );
};

const mapStateToProps = state => ({
  kappSlug: state.app.kappSlug,
  favorites: Utils.getProfileAttributeValues(
    state.app.profile,
    C.ATTRIBUTE_USER_PROFILE_FAVORITES,
  ),
  toggleFavorite: state.app.actions.toggleFavorite,
});

export const FormCard = compose(
  connect(mapStateToProps),
  withHandlers({
    handleToggleFavorite: props => e => {
      e.preventDefault();
      props.toggleFavorite(props.form.slug);
    },
  }),
)(FormCardComponent);

export const FormTile = props => {
  const { path, record: form, components = {}, className } = props;
  const image = Utils.getAttributeValue(
    form,
    C.ATTR_IMAGE,
    Utils.getAttributeValue(
      form.kapp || {},
      C.ATTRIBUTE_KAPP_DEFAULT_FORM_IMAGE,
    ),
  );
  return (
    <Card to={path} components={{ Link, ...components }} className={className}>
      {image && <Image src={image} alt="" />}
      <CardCol>
        <CardRow type="subtitle" className="mt-auto" center>
          <I18n>{form.name}</I18n>
        </CardRow>
      </CardCol>
    </Card>
  );
};
